import React from 'react';
import { oneOfType, bool, array, object } from 'prop-types';

import cx from 'classnames';
import s from './Layout.css';

/**
 * @param children the contents of the layout
 * @param column the layout is column flex-direction instead of the default row flex-direection.
 * @param fullscreen the layout is the full visible viewport.
 * @param mobileColumn the layout will switch to a column flex-direction less than 768px in width
 * @param mobileReverse the layout will switch to a flex-direction reverse less than 768px in width
 * @param staticX the layout is not scrollable in the x-direction
 * @param staticY the layout is not scrollable in the y-direction
 * @param visibleXScroll the layout is scrollable in the x-direction
 * @param autoXScroll the layout is scrollable in the x-direction when there is horizontal overflow
 */
function Layout({ children, column, fullscreen, mobileColumn, mobileReverse, staticX, staticY, visibleXScroll, autoXScroll}) {
  const columnClass = column ? s.column : '';
  const fullscreenClass = fullscreen ? s.fullscreen : '';
  const mobileColumnClass = mobileColumn ? s.mobileColumn : '';
  const mobileReverseClass = mobileReverse ? s.mobileReverse : '';
  const staticClassX = staticX ? s.staticX : '';
  const staticClassY = staticY ? s.staticY : '';
  const visibleXScrollClass =  visibleXScroll ? s.visibleScroll : '';
  const autoXScrollClass = autoXScroll ? s.autoXScroll : '';

  return (
    <div className={cx(s.component, columnClass, fullscreenClass, mobileReverseClass, mobileColumnClass, staticClassX, staticClassY, visibleXScrollClass, autoXScrollClass)}>
      {children}
    </div>
  );
}

Layout.propTypes = {
  children: oneOfType([
    array,
    object
  ]),
  column: bool,
  fullscreen: bool,
  mobileColumn: bool,
  mobileReverse: bool,
  staticX: bool,
  staticY: bool,
  visibleXScroll: bool,
  autoXScroll: bool,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js